import { diffArrays } from 'diff';

function isCodeLine(line: string): boolean {
  const trimmed = line.trim();
  return trimmed.length > 0 && !/^(?:\/\/\s*|#\s*)?\.{3}$/.test(trimmed);
}

export function getAddedDiffLines(code: string): number[] {
  const lines = code.split('\n');
  const hasUnchangedCode = lines.some((line) => line.startsWith(' ') && isCodeLine(line.slice(1)));
  if (!hasUnchangedCode) {
    return [];
  }
  return lines.flatMap((line, index) =>
    line.startsWith('+') && !line.startsWith('+++ ') && isCodeLine(line.slice(1))
      ? [index + 1]
      : [],
  );
}

export function getChangedCodeLines(before: string, after: string): number[] {
  const beforeLines = before.split('\n').map((line) => line.trim());
  const afterLines = after.split('\n').map((line) => line.trim());
  const highlightedLines: number[] = [];
  let lineNumber = 1;
  let hasUnchangedCode = false;

  for (const change of diffArrays(beforeLines, afterLines)) {
    if (change.removed) {
      continue;
    }
    for (const line of change.value) {
      if (isCodeLine(line)) {
        if (change.added) {
          highlightedLines.push(lineNumber);
        } else {
          hasUnchangedCode = true;
        }
      }
      lineNumber += 1;
    }
  }
  return hasUnchangedCode ? highlightedLines : [];
}
